import React from 'react';
import { useAnalytics } from '../hooks/useAnalytics';
import Layout from '../components/Layout';
import DashboardOverview from './DashboardOverview';
import SuggestionsPage from './SuggestionsPage';
import ReportedUsers from './ReportedUsers';
import ReportAnalytics from './ReportAnalytics';
import DatabaseMonitoring from './DatabaseMonitoring';
import RateLimitMonitoring from './RateLimitMonitoring';
import GrafanaMonitoring from './GrafanaMonitoring';
import UsersManagementPage from './UsersManagementPage';
import RidesManagementPage from './RidesManagementPage';
import Festivals from './Festivals';
import Maintenance from './Maintenance';
import VersionPolicy from './VersionPolicy';
import Facebook from './Facebook';
import './Dashboard.css';

interface DashboardProps {
  onLogout: () => void;
  currentTab: string;
  onTabChange: (tab: string) => void;
}

const Dashboard: React.FC<DashboardProps> = ({ onLogout, currentTab, onTabChange }) => {
  const { data, loading, error, lastUpdated, refetch } = useAnalytics(currentTab === 'dashboard');

  if (error) {
    return (
      <Layout onLogout={onLogout} currentTab={currentTab} onTabChange={onTabChange}>
        <div className="error-container">
          <div className="error-message">
            <i className="fas fa-exclamation-triangle"></i>
            <h3>Грешка при зареждане на данните</h3>
            <p>{error}</p>
            <button className="btn btn-primary" onClick={refetch}>
              <i className="fas fa-redo"></i>
              Опитайте отново
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  const renderTabContent = (): React.ReactNode => {
    switch (currentTab) {
      case 'reports':
        return <ReportedUsers />;
      case 'report-analytics':
        return <ReportAnalytics />;
      case 'database-monitoring':
        return <DatabaseMonitoring />;
      case 'rate-limit-monitoring':
        return <RateLimitMonitoring />;
      case 'grafana-monitoring':
        return <GrafanaMonitoring />;
      case 'suggestions':
        return <SuggestionsPage />;
      case 'users':
        return <UsersManagementPage />;
      case 'rides':
        return <RidesManagementPage />;
      case 'festivals':
        return <Festivals />;
      case 'maintenance':
        return <Maintenance />;
      case 'version-policy':
        return <VersionPolicy />;
      case 'facebook':
        return <Facebook />;
      case 'dashboard':
      default:
        return (
          <DashboardOverview
            data={data}
            loading={loading}
            lastUpdated={lastUpdated}
            refetch={refetch}
          />
        );
    }
  };

  return (
    <Layout onLogout={onLogout} currentTab={currentTab} onTabChange={onTabChange}>
      {renderTabContent()}
    </Layout>
  );
};

export default Dashboard;
